import React, { PureComponent } from 'react'
import PropTypes                from 'prop-types'
import { getCategories }        from '../../../api/major'
import { COLOR_LIST }           from '../../constants'

class Category extends PureComponent {

  static propTypes = {
    type: PropTypes.number,
  }

  state = {
    catgoryList: [],
  }

  componentDidMount() {
    const { type } = this.props
    this.getCategories(type)
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.type !== this.props.type) {
      this.getCategories(this.props.type)
    }
  }

  getCategories(type) {
    const param = {
      _s_with_childs: 1,
    }
    getCategories(type, 0, param)
      .then(res => {
        this.setState({
          catgoryList: res.data,
        })
      })
  }

  handleNav(id) {
    const { match, history } = this.props
    history.replace(`${match.url}/${id}`)
  }

  renderDesciption(category) {
    return category.childs.map(d => d.name).join('/')
  }

  render() {
    const { catgoryList } = this.state
    return (
      <div>
        <div className="category-title">
          <p>职业一级类目</p>
          <h2>选择职业方向</h2>
        </div>
        <div className="category-list">
          {catgoryList.map((d, i) => (
            <div className="category" key={i}>
              <div onClick={this.handleNav.bind(this, d.id)}
                   style={{ backgroundColor: COLOR_LIST[i % COLOR_LIST.length] }}>
                <h4>{d.name}</h4>
                <p>{this.renderDesciption(d)}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    )
  }
}

export default Category


// WEBPACK FOOTER //
// ./src/pages/Profession/List/Catgory.js